import Profile from "views/ProfileView";

export default function Page() {
  return (
    <>
      <Profile />
    </>
  );
}
